"use client";

import { useState } from "react";
import { Button } from "@mantine/core";
import { PrivilegeService } from "../services/privilege-service";

interface Props {
  groupId: number;
  onClose: () => void;
  onSuccess?: () => void;
}

export default function PrivilegeGroupAssignModal({ groupId, onClose, onSuccess }: Props) {
  const [userId, setUserId] = useState<number>();
  const [loading, setLoading] = useState(false);
  const { fetch: assignToUser } = PrivilegeService.assignToUser();

  const handleSubmit = async () => {
    if (!userId) return alert("Vui lòng chọn user!");
    setLoading(true);

    await assignToUser({
      user_id: userId,
      privilege_group_id: groupId,
    });

    setLoading(false);
    alert("Gán nhóm quyền thành công!");
    onSuccess?.();
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
      <div className="bg-white rounded-2xl p-6 w-[400px]">
        <h2 className="text-lg font-bold mb-4">Gán nhóm quyền cho người dùng</h2>

        {/* Chọn user */}
        <label className="text-sm mb-2 block">Chọn người dùng</label>
        <select
          className="w-full border rounded-lg px-3 py-2 mb-4"
          value={userId || ""}
          onChange={(e) => setUserId(Number(e.target.value))}
        >
          <option value="">-- Chọn người dùng --</option>
          <option value="1">Nguyễn Văn A</option>
          <option value="2">Trần Thị B</option>
          <option value="3">Phạm C</option>
          {/* TODO: sau này load từ API users */}
        </select>

        {/* Action */}
        <div className="flex justify-end space-x-3">
          <Button variant="outline" onClick={onClose}>
            Hủy
          </Button>
          <Button onClick={handleSubmit} disabled={loading}>
            {loading ? "Đang xử lý..." : "Xác nhận"}
          </Button>
        </div>
      </div>
    </div>
  );
}
